import React from "react";
import styled from "styled-components";
import Layout from "../../containers/layout";
import { fontSize } from "../../styles/Font";

const PageWrapper = styled.div`
  background: #1d192f;
`;
const FooterWrapper = styled.div`
  padding: 45px 10px 90px 10px;
  position: relative;
  // display: flex;
  align-items: center;
`;
const FooterDivider = styled.div`
  margin: 1.5% 0;
  height: 1px;
  background: rgba(164, 174, 198, 0.2);
`;
const FooterHeader = styled.div`
  ${fontSize(18, "B", "white")}
`;
const FooterContentWrapper = styled.div`
  display: flex;
`;
const FooterContent = styled.div`
  ${fontSize(18, "L", "white")}
  margin-right: 50px;
  & > div {
    margin-bottom: 10px;
  }
`;
const HomeFooter = () => {
  return (
    <section>
      <PageWrapper>
        <Layout>
          <FooterWrapper>
            <FooterHeader>세왕상사</FooterHeader>
            <FooterDivider />
            <FooterContentWrapper>
              <FooterContent>
                <div>서울 강동구 진황도로61길 60 세왕상사(주)</div>
                <div>TEL. 02. 2203. 5311 Email. sewang88@naver.com</div>
              </FooterContent>
              <FooterContent>
                <div>대표이사 : 정민성, 사업자번호 : 219-81-19529</div>
                <div>Copyright(C) 2023 SEWANG.corp. All right reserved</div>
              </FooterContent>
            </FooterContentWrapper>
          </FooterWrapper>
        </Layout>
      </PageWrapper>
    </section>
  );
};

export default HomeFooter;
